// extracted by mini-css-extract-plugin
export default {"container":"Progress_container__eKdq+","label":"Progress_label__0A-EK","percentage":"Progress_percentage__fW7SE"};